import React, { lazy, Suspense } from 'react';

// The 3D engine is large, so it is downloaded only when a viewer is actually shown.
const ModelViewer = lazy(() => import('./ModelViewer.jsx'));

export default function LazyModelViewer(props) {
  return <Suspense fallback={<div className={props.className || ''} aria-busy="true" />}><ModelViewer {...props} /></Suspense>;
}
